<template>
  <custom-misc>
    <span class="icon-page-misc mb-2">
      <CoffeeIcon />
    </span>

    <div class="text-center mb-1">
      <h2 class="text-center">Você foi desconectado!</h2>
      <p class="text-center">
        Sua sessão expirou. Faça novamente o login para acessar o VacinaSESI.
      </p>
    </div>

    <button
        @click="handleRedirectToLogin"
        type="button"
        class="btn btn-misc w-100"
    >
      Voltar para o login
    </button>
  </custom-misc>
</template>

<script>
import CustomMisc from '@/views/components/custom/miscellaneous/CustomMisc'
import { CoffeeIcon } from 'vue-feather-icons'
import {clearStore} from "@/auth/utils";

export default {
  title: 'Sessão expirada',

  components: {
    CustomMisc,
    CoffeeIcon,
  },

  methods: {
    handleRedirectToLogin() {
      clearStore()
      this.$router.replace({ name: 'auth-login' });
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-misc.scss';
</style>
